import { useFormContext } from 'react-hook-form';
import { FormInputField, FormSwitchField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { LocalizedMinorHighlight, LocalizedSubsectionTitle } from '@mews-commander/ui';
import { CounterFormField, CounterFormValues } from './formMapping';

export const CounterFormProformaCounterSettings = () => {
    const { formState } = useFormContext<CounterFormValues>();
    const isDefault = formState.defaultValues?.isDefault === true;

    return (
        <Stack distribution="stretch" vertical spacing="300">
            <LocalizedSubsectionTitle textKey={TextKey.CounterTypeSettings} />

            <LocalizedMinorHighlight textKey={TextKey.ProformaCounter} />

            <FormSwitchField
                helper={<LocalizedText textKey={TextKey.UseProformaCounterAsDefaultHelper} />}
                label={<LocalizedText textKey={TextKey.UseProformaCounterAsDefault} />}
                name={CounterFormField.IsDefault}
                disabled={isDefault}
            />

            <FormInputField
                helper={<LocalizedText textKey={TextKey.ProformaCounterTitleHelper} />}
                placeholder={<LocalizedText textKey={TextKey.ProformaCounterTitlePlaceholder} />}
                label={<LocalizedText textKey={TextKey.ProformaCounterTitle} />}
                name={CounterFormField.Title}
                size="medium"
            />
        </Stack>
    );
};
